import { ITabData } from '../types';

export function getActiveTab(yOffset: number, clauses: ITabData[]) {
  const len = clauses.length;

  if (len < 1) {
    return null;
  }

  let lastHovered = 0;

  for (let i = 0; i < len; i += 1) {
    if (yOffset < clauses[i].point) {
      break;
    } else {
      lastHovered = Math.max(i, lastHovered);
    }
  }

  return clauses[lastHovered];
}
